// Our 'redux-promise-middleware' auto creates these xyz_FULFILLED events, as well as error events in the event
// of an error. In most cases I'm not currently not using that functionality, so, I don't know create all the constants.
// Consider going back to just 'react-promise' lib.

export const AUTH_USER_SET = 'AUTH_USER_SET';
export const ADMIN_CHECK = 'ADMIN_CHECK';
export const USER_SET = 'USER_SET';
export const UPDATE_USERNAME = 'UPDATE_USERNAME';

export const GAME_SELECTED = 'GAME_SELECTED';    // not a promise (so for sure no FULFILLED.
export const CLUE_SELECTED = 'CLUE_SELECTED';    // not a promise
export const UPDATE_CLUES = 'UPDATE_CLUES';
export const FETCH_GAMES = 'FETCH_GAMES';
export const FETCH_GAME = 'FETCH_GAME';
export const FETCH_GAME_STATES = 'FETCH_GAME_STATES';
export const FETCH_CLUE_ICONS = 'FETCH_CLUE_ICONS';
export const FETCH_STATS_FOR_GAME = 'FETCH_STATS_FOR_GAME';
export const FETCH_LEADERBOARD_FOR_GAME = 'FETCH_LEADERBOARD_FOR_GAME';
export const FETCH_STATS_RECENT = 'FETCH_STATS_RECENT';
export const FETCH_REVIEWS = 'FETCH_REVIEWS';
export const FETCH_REPORTS = 'FETCH_REPORTS';

export const CREATE_GAME = 'CREATE_GAME';
export const DELETE_GAME = 'DELETE_GAME';
export const UPDATE_GAME_FULFILLED = 'UPDATE_GAME_FULFILLED';

export var UPDATE_GAME = 'UPDATE_GAME';
export var UPDATE_STAT = 'UPDATE_STAT';
export var LATLON_QUERY = 'LATLON_QUERY';



// WEBPACK FOOTER //
// ./src/constants/ActionTypes.js